import type React from 'react';

import { translationKey } from '@change-corgi/core/i18n';

import { GradientStats } from '#src/app/pages/about/impact/shared/components';

const STATS = [
	{
		figure: translationKey('corgi.impact_page.stats.signatures.figure'),
		label: translationKey('corgi.impact_page.stats.signatures.label'),
	},
	{
		figure: translationKey('corgi.impact_page.stats.victories.figure'),
		label: translationKey('corgi.impact_page.stats.victories.label'),
	},
	{
		figure: translationKey('corgi.impact_page.stats.hourly.figure'),
		label: translationKey('corgi.impact_page.stats.hourly.label'),
	},
] as const;

export const StatsBand: React.FC<EmptyProps> = () => {
	return (
		<section className="container pb-16 md:pb-32">
			<GradientStats stats={STATS} align="start" />
		</section>
	);
};
